import React from "react";

const SmallCard = ({ title, children, className }) => {
  return (
    <div className={`m-5 rounded border overflow-hidden shadow ${className}`}>
      <div className="h-12  w-full flex items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
        {title}
      </div>
      {children}
    </div>
  );
};

export default SmallCard;
